export default __webpack_public_path__ + "static/media/breakfast_14.58d41802.jpg";